import { useFormContext } from '@updater/ui-informant';
import { Box, TextLink } from '@updater/ui-uds';
import styled from '@emotion/styled';
import { useTracking } from 'react-tracking';
import { TrackEventInput } from '@updater/ui-tracker';

const SwitchContainer = styled(Box)`
  margin-top: -35px;
`;

interface FormContextValue {
  movingFromOutsideCountry: 'Yes' | 'No';
}

export const FromAddressSwitch = () => {
  const { values, setFieldValue } = useFormContext();
  const { trackEvent } = useTracking<TrackEventInput<unknown>>({
    object: 'from_address_intl_switch',
  });
  const setMovingFromOutsideCountry = (movingFromOutsideCountry: boolean) => {
    trackEvent({
      verb: 'clicked',
      details: {
        movingFromOutsideCountry,
      },
    });
    return setFieldValue(
      'movingFromOutsideCountry',
      movingFromOutsideCountry ? 'Yes' : 'No'
    );
  };

  return (
    <SwitchContainer>
      {(values as FormContextValue).movingFromOutsideCountry === 'No' ? (
        <TextLink
          data-testid="moving-no"
          onClick={() => setMovingFromOutsideCountry(true)}
        >
          I’m moving from outside the USA
        </TextLink>
      ) : (
        <TextLink
          data-testid="moving-yes"
          onClick={() => setMovingFromOutsideCountry(false)}
        >
          I’m moving from inside the USA
        </TextLink>
      )}
    </SwitchContainer>
  );
};
